<template>
  <div v-if="pristineAccount" class="my-account">
    <!-- KUNDUPPGIFTER -->
    <template v-if="customerDetails">
      <oie-my-customer-details
        :customer-details="customerDetails"
        :disabled="!pristineAccount.isAdmin"
        @save="saveCustomerDetails"
        @exit="exitCustomerDetails"></oie-my-customer-details>

      <oie-base-divider></oie-base-divider>
    </template>

    <!-- MINA UPPGIFTER -->
    <oie-my-user-details
      :user-details="userDetails"
      @save="saveUserDetails"
      @exit="exitUserDetails"></oie-my-user-details>
  </div>
</template>

<script>
import httpService from '@/core/http-service'
import _ from 'lodash'

export default {
  data: () => ({
    pristineAccount: null,
    userDetails: null,
    customerDetails: null
  }),
  computed: {
    isOneUserCustomer() {
      return this.pristineAccount && !this.pristineAccount.isMultiUser
    },
    isMultiUserCustomer() {
      return this.pristineAccount && this.pristineAccount.isMultiUser
    }
  },
  async mounted() {
    const response = await httpService.get('auth/myaccount')
    this.pristineAccount = response.data

    this.extractUserDetails()
    this.extractCustomerDetails()
  },
  methods: {
    extractUserDetails() {
      const commonProperties = ['fullName', 'firstName', 'lastName', 'userPhone', 'userEmail', 'showListPrices', 'invoiceAddress', 'isCompany', 'isMultiUser', 'alias', 'languageOptions']
      if(this.isOneUserCustomer) {
        this.userDetails = _.pick(this.pristineAccount, [...commonProperties, 'customerNumber', 'customerName', 'language', 'vatNumber'])
      }
      if(this.isMultiUserCustomer) {
        this.userDetails = _.pick(this.pristineAccount, [...commonProperties])
      }
    },
    extractCustomerDetails() {
      if(this.isMultiUserCustomer) {
        this.customerDetails = _.pick(this.pristineAccount, ['customerNumber', 'customerName', 'vatNumber', 'invoiceAddress', 'customerPhone', 'language', 'languageOptions', 'customerEmail', 'isCompany', 'orderConfirmationEmailCopy'])
      }
    },
    async saveUserDetails(toggle) {
      await httpService.post('auth/myaccount/user', this.userDetails)
      this.pristineAccount = _.merge({}, this.pristineAccount, this.userDetails)

      // this is so that user name in header updates, could probably be done in a better way?
      this.clientModel.user.firstName = this.userDetails.firstName
      this.clientModel.user.lastName = this.userDetails.lastName
      if(this.userDetails.isCompany) {
        this.clientModel.user.customerName = this.userDetails.customerName
      }

      toggle()
    },
    exitUserDetails(toggle) {
      this.extractUserDetails()
      toggle()
    },
    async saveCustomerDetails(toggle) {
      await httpService.post('auth/myaccount/customer', this.customerDetails)
      this.pristineAccount = _.merge({}, this.pristineAccount, this.customerDetails)

      // this is so that company name in header updates, could probably be done in a better way?
      this.clientModel.user.customerName = this.customerDetails.customerName

      toggle()
    },
    exitCustomerDetails(toggle) {
      this.extractCustomerDetails()
      toggle()
    }
  }
}
</script>

<style lang="scss">
.my-account >*:not(:last-child) {
  margin-bottom: measure(half);

  @include media(large) {
    margin-bottom: measure(full);
  }
}
</style>
